module.exports = __webpack_public_path__ + "img/ic-upload-file.5fcc9905.svg";